export class CompanionTextureError extends Error {}
